import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "María del Carmen R.",
    place: "Presidenta de comunidad · Telde",
    rating: 5,
    body: "Un cambio brutal desde que Moisés se encarga del mantenimiento del edificio. Viene el mismo día, explica todo con calma y la factura es la del presupuesto. Ni una sorpresa en dos años.",
  },
  {
    name: "Javier P.",
    place: "Vivienda · Vecindario",
    rating: 5,
    body: "Se me fue la luz un domingo por la tarde. En hora y media estaba en casa y a las dos horas todo funcionando. Trato cercano, sin humos y precio muy razonable.",
  },
  {
    name: "Restaurante La Marea",
    place: "Negocio · Arinaga",
    rating: 5,
    body: "Reforma completa del cuadro y del salón. Trabajo limpísimo, sin cortarnos horas de servicio y con boletín en mano. Recomendado 100%.",
  },
];

export default function Testimonials() {
  return (
    <section id="opiniones" className="relative py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="section-label mb-4">07 · Opiniones reales</span>
          <h2 className="font-display text-4xl sm:text-5xl text-white mt-4 leading-[0.95]">
            Lo que dicen quienes ya <span className="text-[#00E5FF]">han encendido</span> la luz.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative rounded-2xl border border-white/8 bg-[#121620]/70 p-7"
            >
              <Quote size={22} className="text-[#E57C23]/60 mb-4" />
              <p className="text-[15px] text-white/85 leading-relaxed">&ldquo;{r.body}&rdquo;</p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <div className="font-display text-white">{r.name}</div>
                  <div className="text-[12px] text-white/50 mt-0.5">{r.place}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: r.rating }).map((_, k) => (
                    <Star key={k} size={13} className="fill-[#E57C23] text-[#E57C23]" />
                  ))}
                </div>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
